import { Components } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import screenfull from "screenfull";
import { FlexColumn } from "../../Styles";
import { PlayerControlsContainer } from "../style";
import VideoPlayerProps from "../VideoPlayer";
import ControlsButton from "./ControlsButton";
import TitleDescription from "./TitleDescription";

const PlayerControls = (props: VideoPlayerProps.PlayerControlsProps) => {
  const {
    currentTime,
    isPlaying,
    volume,
    setVolume,
    isVolumeShow,
    setIsVolumeShow,
    handleSeekTo,
    isSettingsShow,
    setIsSettingsShow,
    playbackSpeed,
    setPlaybackSpeed,
    setIsPlaying,
    video_description,
    video_title,
    duration,
    isViewOnly,
  } = props;
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [showControls, setShowControls] = useState(false);

  const controlsButtonList: VideoPlayerProps.ControlsButton[] = [
    {
      iconType: isPlaying ? "Pause" : "Play",
      onClick: () => {},
      disabled: false,
    },
    {
      iconType: "SkipRwTenS",
      onClick: (e: Event) => {
        e.stopPropagation();
        handleSeekTo(currentTime - 10 < 0 ? 0 : currentTime - 10);
      },
      disabled: false,
    },
    {
      iconType: "SkipFfTenS",
      onClick: (e: Event) => {
        e.stopPropagation();
        handleSeekTo(currentTime + 10 > duration ? duration : currentTime + 10);
        currentTime + 10 > duration && setIsPlaying(false);
      },
      disabled: false,
    },
    {
      iconType: volume < 0.1 ? "Volume" : volume > 0.7 ? "Volume2" : "Volume1",
      onClick: (e: Event) => {
        e.stopPropagation();
        setIsVolumeShow(!isVolumeShow);
      },
      disabled: false,
    },
    !isViewOnly && {
      iconType: "Settings",
      onClick: (e: Event) => {
        e.stopPropagation();
        setIsSettingsShow(!isSettingsShow);
      },
      disabled: false,
    },
    !isViewOnly && {
      iconType: screenfull.isFullscreen ? "Minimize2" : "Maximize2",
      onClick: (e: Event) => {
        e.stopPropagation();
        const reactPlayer = document.querySelector(".react-player");
        if (reactPlayer) {
          screenfull.toggle(reactPlayer);
        }
      },
      disabled: false,
    },
  ].filter((item) => item) as VideoPlayerProps.ControlsButton[];

  return (
    <PlayerControlsContainer
      $isShow={isPlaying ? showControls : !isPlaying}
      onMouseMove={() => {
        setShowControls(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          setShowControls(false);
          isPlaying && setIsVolumeShow(false);
          isPlaying && setIsSettingsShow(false);
        }, 3000);
      }}
    >
      <FlexColumn $gapInPx={8}>
        <TitleDescription
          {...{ currentTime, video_description, video_title, duration }}
        />
        <Components.LinearProgress
          percentage={
            (Number(currentTime.toFixed()) / Number(duration.toFixed())) * 100
          }
          size="Small"
          type="Primary"
          showPercentage={false}
          onClick={(percentage) => handleSeekTo((percentage * duration) / 100)}
        />
        <ControlsButton
          controlsButtonList={controlsButtonList}
          isVolumeShow={isVolumeShow}
          volume={volume}
          setVolume={setVolume}
          setIsVolumeShow={setIsVolumeShow}
          isSettingsShow={isSettingsShow}
          setIsSettingsShow={setIsSettingsShow}
          playbackSpeed={playbackSpeed}
          setPlaybackSpeed={setPlaybackSpeed}
          isViewOnly={isViewOnly}
        />
      </FlexColumn>
    </PlayerControlsContainer>
  );
};

export default PlayerControls;
